import styles from './ccf-dialog-box.module.scss';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Typography,
  PropTypes,
  ButtonProps,
  Box,
  TypographyProps,
  DialogProps,
} from '@mui/material';
import { CcfButton } from '../../core/ccf-button/ccf-button';
import { CcfCloseIcon } from '../../icons/ccf-close-icon/ccf-close-icon';
import { CcfTypography } from '../ccf-typography/ccf-typography';

export interface CcfDialogBoxProps {
  isOpen: boolean;
  handleOnClickOfHeaderCloseButton?: React.MouseEventHandler;
  handleOnClose?: DialogProps['onClose'];
  children?: React.ReactNode;
  title: string;
  primaryButtonText: string;
  secondaryButtonText?: string;
  primaryButtonProps?: ButtonProps;
  secondaryButtonProps?: ButtonProps;
  dialogTitleProps?: TypographyProps;
  component?: React.ReactElement;
  dividers?: boolean;
}

/**
 * Component used to display dialog box
 * @param param0 - CcfDialogBoxProps
 * @example <CCfDialogBox />
 * @returns dialog box
 */
export function CcfDialogBox({
  isOpen,
  handleOnClickOfHeaderCloseButton,
  handleOnClose,
  children,
  title,
  primaryButtonText,
  secondaryButtonText,
  primaryButtonProps = {},
  secondaryButtonProps = {},
  dialogTitleProps = {},
  component,
  dividers = true,
}: CcfDialogBoxProps) {
  const content = component ? component : <DialogContentText>{children}</DialogContentText>;

  return (
    <Box className={styles.ccfDialogParent}>
      <Dialog
        open={isOpen}
        onClose={handleOnClose}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth={true}
      >
        <DialogTitle id="scroll-dialog-title" className={styles.ccfDialogHeader}>
          <CcfTypography className={styles.ccfDialogHeaderTitle} {...dialogTitleProps}>{title}</CcfTypography>

          <CcfButton className={styles.ccfDialogHeaderClose} onClick={handleOnClickOfHeaderCloseButton}>
            <CcfCloseIcon viewBox="0 0 20 20"></CcfCloseIcon>
          </CcfButton>
        </DialogTitle>

        <DialogContent dividers={dividers}>{content}</DialogContent>

        <DialogActions>
          {secondaryButtonText && (
            <CcfButton {...secondaryButtonProps}>
              {secondaryButtonText}
            </CcfButton>
          )}

          <CcfButton {...primaryButtonProps} primary>
            {primaryButtonText}
          </CcfButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default CcfDialogBox;
